var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12935_44636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.98571 4.6875C4.95016 4.6875 4.11071 5.52695 4.11071 6.5625C4.11071 7.59805 4.95016 8.4375 5.98571 8.4375C7.02125 8.4375 7.86071 7.59805 7.86071 6.5625C7.86071 5.52695 7.02086 4.6875 5.98571 4.6875ZM17.5131 1.25H2.51305C1.16735 1.25 0.0478516 2.36914 0.0478516 3.75V16.25C0.0478516 17.6309 1.16699 18.75 2.5127 18.75H17.5127C18.8936 18.75 20.0127 17.6309 20.0127 16.25V3.75C20.0131 2.36914 18.9271 1.25 17.5131 1.25ZM18.1381 15.9883L12.7943 8.72656C12.6966 8.54688 12.474 8.4375 12.2357 8.4375C11.9969 8.4375 11.774 8.54562 11.6416 8.72574L7.4775 14.3546L6.02868 12.5539C5.89426 12.3867 5.67969 12.2879 5.45172 12.2879C5.22352 12.2879 5.00914 12.3867 4.87438 12.5539L1.92438 16.2183C1.92438 16.2172 1.92438 16.2195 1.92438 16.2183L1.92282 3.75C1.92282 3.40539 2.20321 3.125 2.54782 3.125H17.5478C17.8924 3.125 18.1728 3.40539 18.1728 3.75V15.9883H18.1381Z",
    fill: "#707A83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12935_44636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.0478516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.b921cb5835fb80be2f91e3b82c3056b3.svg";
export { ForwardRef as ReactComponent };